export class VehiclesGetPageAction {
    public static readonly type = '[Vehicles] get list';
    constructor(public payload?: number) {}
}
